import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full overflow-hidden bg-gradient-to-b from-cream via-amber-50/30 to-cream" data-id="element-49">
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-12 md:py-16" data-id="element-50">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-51">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left" data-id="element-52">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} data-id="element-53">
              <span className="inline-block px-4 py-2 mb-6 text-sm font-semibold text-orange bg-orange/10 rounded-full border border-orange/20" data-id="element-54">
                📗 Ebook Completo + Bono Exclusivo
              </span>
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} className="font-display text-6xl md:text-8xl text-brown-dark mb-4 leading-none tracking-tight" data-id="element-55">
              Recetas
              <br data-id="element-56" />
              <span className="text-orange" data-id="element-57">Rescate</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="font-heading text-xl md:text-2xl text-orange font-semibold mb-4" data-id="element-58">
              Soluciones de 15 Minutos para Mamás Ocupadas
            </motion.p>

            <motion.p initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="font-body text-lg md:text-xl text-brown-light max-w-2xl mb-8 leading-relaxed" data-id="element-59">
              Un sistema completo de recetas rescate diseñado específicamente
              para mamás argentinas ocupadas que necesitan resolver la comida
              familiar en 15 minutos o menos, con ingredientes simples que ya
              tienen en casa.
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} data-id="element-60">
              <motion.a href="https://www.mamaexpres.com/cart/53191481131281:1" whileHover={{
              scale: 1.03
            }} whileTap={{
              scale: 0.98
            }} className="inline-flex items-center gap-3 px-8 py-4 bg-orange text-white font-semibold text-lg rounded-full shadow-warm-lg hover:bg-orange-dark hover:shadow-warm-xl transition-all duration-300" data-id="element-61">
                ¡Quiero mis Recetas Rescate!
                <ArrowRightIcon className="w-5 h-5" data-id="element-62" />
              </motion.a>
            </motion.div>

            <motion.p initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="mt-4 text-sm text-brown-muted" data-id="element-63">
              ⚡ Descarga inmediata • Acceso de por vida
            </motion.p>
          </div>

          {/* Hero Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="flex-1 w-full max-w-md md:max-w-none" data-id="element-64">
            <img src="https://cdn.magicpatterns.com/uploads/oiUp8FBBoerUBWNhnje4v4/mama_expres_foto_1.png" alt="Mamá argentina sonriendo con un plato de comida casera recién preparado" className="w-full rounded-3xl shadow-warm-xl object-cover aspect-[4/3]" data-id="element-65" />
          </motion.div>
        </div>
      </div>
    </section>;
}